import * as React from "react";
const SvgFiRrChartPieAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-chart-pie-alt_svg__a)">
      <path d="M18.713 12H14a2 2 0 0 1-2-2V5.274a3 3 0 0 0-1.166-2.383 2.87 2.87 0 0 0-2.481-.534 10.969 10.969 0 0 0 .553 21.414 11 11 0 0 0 12.734-8.114 2.88 2.88 0 0 0-.533-2.485A3.06 3.06 0 0 0 18.713 12m.988 3.168A8.969 8.969 0 1 1 8.84 4.3a.87.87 0 0 1 .765.172 1.02 1.02 0 0 1 .4.806V10a4 4 0 0 0 4 4h4.712a1.04 1.04 0 0 1 .816.4.88.88 0 0 1 .167.768" />
      <path d="M23.65 7.446A10.07 10.07 0 0 0 16.583.372a2.1 2.1 0 0 0-1.316.075A2 2 0 0 0 14.02 2.3V7a3 3 0 0 0 3 3h4.719a2.008 2.008 0 0 0 1.913-2.554M17.016 8a1 1 0 0 1-1-1l-.008-4.693a.05.05 0 0 1 .025-.01h.026A8.07 8.07 0 0 1 21.734 8z" />
    </g>
    <defs>
      <clipPath id="fi-rr-chart-pie-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrChartPieAlt;
